import './DownloadsBlock.scss'

import React from 'react'
import {ImageType, LinkBaseType, WysiwygType} from '../../types'
import {style} from '../../util/style'
import {Theme} from '../Theme'
import {Block} from './Blocks'

const styles = style('downloadsblock', ['item'])

export type DownloadsBlockType = {
	title?: string
	text?: WysiwygType
	items: Array<DownloadsBlockItemType>
}

type DownloadsBlockItemType = {
	text: WysiwygType
	file: FileOrImageType
}

type FileOrImageType = ({type: 'file'} & LinkBaseType) | ImageType

export const DownloadsBlock: React.FC<
	DownloadsBlockType & {container?: boolean; sidebar?: boolean}
> = ({container, sidebar, title, text, items}) => {
	if (!items || items.length === 0) return null

	return (
		<Block className={styles()} container={container} sidebar={sidebar}>
			{title && (
				<Theme.H5 className={styles('title')} mod="grey">
					{title}
				</Theme.H5>
			)}
			{text && (
				<div className={styles('text')}>
					<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
				</div>
			)}
			<div className={styles('items')}>
				{items.map((item, i) => (
					<DownloadsBlockItem key={i} {...item} />
				))}
			</div>
		</Block>
	)
}

const DownloadsBlockItem: React.FC<DownloadsBlockItemType> = ({text, file}) => {
	if (!file) return null

	const fileOrImagePath: (FileOrImageType) => string | null = (input) =>
		input && (input.src || input.url)
	const to: string | null = fileOrImagePath(file)

	return (
		<div className={styles.item()}>
			<div className={styles.item('row')}>
				<div className={styles.item('content')}>
					{text && <Theme.Wysiwyg>{text}</Theme.Wysiwyg>}
					{!text && <p>{to.replace(/^.*[\\\/]/, '')}</p>}
				</div>
				{to && (
					<Theme.Link
						to={to}
						className={styles.item('link')}
						mod="bold"
						iconafter="chevronRight"
						download={to.replace(/^.*[\\\/]/, '')}
					>
						Download
					</Theme.Link>
				)}
			</div>
		</div>
	)
}
